<template>
		<template v-if="!isLoading">
<!--        <img :class="className" :style="style" v-if="src" :src="basePath + '' + src" @error="handleImageError" :id="id">-->
        <video :class="className" controls autoplay :src="basePath + '' + src" @error="handleImageError" :id="id"></video>
		</template>
</template>

<script setup>
import {ref, defineProps, toRefs, watch, onMounted} from "vue";
const prod_url = 'https://cdn.moviestart.ru';
const dev_url = 'https://storage.yandexcloud.net/scriptcdn-dev';

let isLoading = ref(true);

let basePath = ref(prod_url);

function getBasePath() {
  if (src.value.startsWith('/images')) {
    basePath.value = '';
    isLoading.value = false;
    return;
  }
  if (window.APP_ENV === 'dev') {
    basePath.value = dev_url;
  }
	isLoading.value = false;
}

// <your-component :style="{ width: '100px', height: '200px' }"></your-component>
const props = defineProps({
  src: {
    type: String,
		default: '',
    required: true
  },
	className: {
		type: String,
		default: ''
	},
  style: {
    type: Object,
    default: () => ({})
  },
	id: {}
});
const { src } = toRefs(props);

onMounted(() => {
	getBasePath();
});

watch(() => src, () => {
  getBasePath();
})

function handleImageError() {
  if (window.APP_ENV === 'dev' && basePath.value === dev_url) {
		basePath.value = prod_url;
	}
}

</script>

<style scoped>

</style>